(() => {
	ko.components.register('player-select-button', {
		template: { element: 'template-player-select-button' },
		viewModel: function(params) {
			this.title = params.title;
			this.items = params.items;
			this.value = params.value;
			this.isShowOptions = ko.observable(false);

			this.toggleOptions = () => this.isShowOptions(!this.isShowOptions());
			this.showOptions = () => this.isShowOptions(true);
			this.hideOptions = () => this.isShowOptions(false);

			this.value.subscribe(() => this.hideOptions())
		}
	});
})();